// Single source of truth for game limits / tunables. Previously these were
// inline literals duplicated across server (room.ts) and client (nickname.ts),
// which drifted (e.g. the nickname cap was 20 on the client but 24 on the
// server). Import from here on both ends so they can't diverge.

export const LIMITS = {
  /** Max non-host seats in a room. */
  maxPlayers: 16,
  /** Min non-host players required to start. */
  minPlayers: 4,
  /** Max characters in a player name (server-authoritative; client mirrors). */
  nameMax: 24,
  /** Max characters in a chat message. */
  chatMax: 240,
  /** Minimum spacing between a player's chat messages, ms. */
  chatRateMs: 500,
  /** Sliding-window size kept per chat channel. */
  chatWindow: 80,
  /** Discussion-timer clamp bounds, ms. */
  timerMinMs: 5_000,
  timerMaxMs: 30 * 60_000,
  /** Absolute room lifetime since creation, ms. */
  roomTtlMs: 1000 * 60 * 60 * 6,
  /** Zero-connection grace before a room is reclaimed as abandoned, ms. */
  abandonedGraceMs: 1000 * 60 * 2,
  /** How long the host may be disconnected before the moderator role is handed
   *  off to a connected player, ms. */
  hostHandoffGraceMs: 1000 * 45,
  /** Hard ceiling on concurrent rooms (flood guard). */
  maxRooms: 2000,
} as const;
